import { API } from "../axios/API";

export const evaluacionesService = {
  async getEvaluacionesConfig() {
    const res = await API.get("/evaluaciones-config");
    return res.data;
  },
  async updateEvaluacionesConfig(data) {
    const res = await API.put("/evaluaciones-config", data);
    return res.data;
  },
  async getEvaluaciones(data) {
    const res = await API.post("/evaluaciones", data);
    return res.data;
  },
  async create(data) {
    const res = await API.post("/evaluaciones", data);
    return res.data;
  },
  async evaluacionesByAbogado(data) {
    const res = await API.post("/evaluaciones/byAbogado", data);
    return res.data;
  },
  async lastByAbogado(data) {
    const res = await API.post("/evaluaciones/last", data);
    return res.data;
  },
};


